import React, { useCallback, useMemo } from 'react';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';

import styles from '../styles';
import LockNumber from '../../lockNumber/LockNumber';
import { doesArrayHasLength, isUndefined } from '../../../utils/isDefined';
import ShowQrCode from '../../showQrCode/ShowQrCode';
import { translate } from '../../../i18n/I18nProvider';
import withUserCheck from '../../../utils/withUserCheck';
import Optional from '../../../utils/optional';
import { actions as swapSimcardReduxActions } from '../../../modals/swapSimcard/reducers';
import createSubject from '../../../utils/createSubject';
import can from '../../../utils/can';
import CustomColorButton from '../../customButtons/CustomColorButton';
import withSettings from '../../../utils/withSettings';
import { CAN_SWAP_STATUSES } from '../../../consts/initialValues';
import checkShouldShowQRCode from '../../../utils/checkShouldShowQRCode';

export function ActionsButtons({
  classes,
  data = {},
  hasClientAccounts,
  openSwapSimcard,
  isLoading,
  problems,
  settings,
  subscription,
  fromExtraSimcards = false
}) {
  const {
    activationCode,
    simcard,
    isESimCard = false,
    isIoTCard = false
  } = data;

  const onSwapClick = useCallback(
    () => {
      const { id, msisdn, mobile_network, client_id } = simcard;
      openSwapSimcard({
        simcard: { id, msisdn, mobile_network, client_id, isESimCard },
        problems
      });
    },
    // eslint-disable-next-line
    [simcard, problems]
  );

  const shouldShowQRCode = useMemo(
    () =>
      checkShouldShowQRCode({
        subscription,
        hasClientAccounts,
        isESimCard,
        activationCode
      }),
    [subscription, hasClientAccounts, isESimCard, activationCode]
  );

  return (
    <div className={classes.buttonsContainer}>
      {shouldShowQRCode && (
        <div className={classes.buttonContainer}>
          <ShowQrCode
            activationCode={activationCode}
            icc={simcard?.icc}
            number={simcard?.msisdn}
            subStatus={subscription?.status}
          >
            <CustomColorButton
              color={settings.colors.modal_header_text}
              backgroundColor={settings.colors.modal_header}
            >
              {translate('SWAP_SIMCARD.SHOW_QR_CODE')}
            </CustomColorButton>
          </ShowQrCode>
        </div>
      )}
      {simcard?.mobile_network?.brand === 'TDC' &&
        can('swap', createSubject('SimCard', simcard)) && (
          <>
            <CustomColorButton
              color={settings.colors.modal_header_text}
              backgroundColor={settings.colors.modal_header}
              onClick={onSwapClick}
              disabled={
                isLoading ||
                isUndefined(subscription?.id) ||
                !CAN_SWAP_STATUSES.includes(subscription?.status)
              }
              tooltipText={isIoTCard ? translate('TOOLTIP.IOT_SWAP_INFO') : ''}
              tooltipOnDisabled={
                !CAN_SWAP_STATUSES.includes(subscription?.status)
                  ? translate('TOOLTIP_DISABLED_WHEN_NOT_ACTIVE')
                  : ''
              }
            >
              {translate(
                fromExtraSimcards
                  ? 'BUTTON.SWAP_EXTRA_SIMCARD'
                  : 'BUTTON.SWAP_SIMCARD'
              )}
            </CustomColorButton>
          </>
        )}
      {!fromExtraSimcards && (
        <div className={classes.buttonContainer}>
          {simcard?.mobile_network?.brand === 'TDC' && (
            <LockNumber
              data={simcard}
              tooltipOnDisabled={
                !CAN_SWAP_STATUSES.includes(subscription?.status)
                  ? translate('TOOLTIP_DISABLED_WHEN_NOT_ACTIVE')
                  : ''
              }
              disabled={!CAN_SWAP_STATUSES.includes(subscription?.status)}
            />
          )}
        </div>
      )}
    </div>
  );
}
const mapStatesToProps = ({ selectClient, loader, user }) => {
  return {
    hasClientAccounts: Optional(
      selectClient.selectedClient?.metadata?.account_ids
    )
      .map(accounts => doesArrayHasLength(accounts))
      .or(false),
    isLoading: loader.isLinearVisible,
    problems: user.subscription?.problems
  };
};

const mapDispatchToProps = {
  openSwapSimcard: swapSimcardReduxActions.openDialog
};

export default flowRight(
  withSettings,
  withUserCheck,
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(ActionsButtons);
